import React, { Component } from "react";
import { connect } from "react-redux";
import Draggable from "react-draggable";
import { focusSwAction, changeSwIndexAction } from "../../redux/ui/actions";

const mapStateToProps = (state) => {
    return {
        focusSw: state.uiReducer.focusSw,
    };
};

class SwPop extends Component {
    constructor(props) {
        super(props);
        this.focusSw = this.focusSw.bind(this);
        this.stopSw = this.stopSw.bind(this);

        this.focusSw(this.props.focusName);
        this.state = { pos: { x: 0, y: 0 } };
    }

    /*
     * 選択サブウィンドウを前面表示
     * @since hara 2021-04-06
     */
    focusSw(sw) {
        if (sw !== "editer" && sw !== "prob") sw = "menu";

        const arr = [...this.props.focusSw];
        const oldIndex = arr.indexOf(sw);
        arr.splice(oldIndex, 1);
        arr.push(sw);

        this.props.dispatch(focusSwAction(arr));
    }

    /*
     * サブウィンドウが画面外の場合画面内に移動
     * @since hara 2022-04-05
     */
    stopSw(e, data) {
        const docElem = document.documentElement; //ビューポート(全画面)
        const wrapW = window.innerWidth || docElem.clientWidth; //ビューポート幅
        const wrapH = window.innerHeight || docElem.clientHeight; //ビューポート高さ
        const swW = data.node.clientWidth; //サブウィンドウ幅
        const swH = data.node.clientHeight; // //サブウィンドウ高さ
        const handleSize = 20; //つかむ最小サイズ

        //console.log(data.x);

        if (data.node.className.indexOf("SwR") === -1) {
            const outL = -(swW - handleSize); //左画面外
            const outR = wrapW - handleSize; //右画面外
            const outT = -(swH - handleSize); //上画面外
            const outB = wrapH - handleSize; //下画面外
            if (data.x < outL || outR < data.x || data.y < outT || outB < data.y) {
                //画面外の場合
                // Draggable element center coordinates (x,y)
                const center = {
                    x: data.x + swW / 2,
                    y: data.y + swH / 2,
                };

                // The margin from the draggable's center,
                // to the viewport sides (top, left, bottom, right)
                const margin = {
                    top: center.y - 0,
                    left: center.x - 0,
                    bottom: wrapH - center.y,
                    right: wrapW - center.x,
                };

                // sort and get the nearest viewport side.
                const sorted = Object.keys(margin).sort((a, b) => margin[a] - margin[b]);
                const nearSide = sorted[0];

                // new draggable sticky position`
                const pos = {
                    top: { y: outT, x: data.x },
                    left: { y: data.y, x: outL },
                    bottom: { y: outB, x: data.x },
                    right: { y: data.y, x: outR },
                };

                this.setState({ pos: pos[nearSide] });
            } else {
                //画面内の場合
                this.setState({ pos: { y: data.y, x: data.x } });
            }
        } else {
            const outR = swW - handleSize; //左画面外
            const outL = -(wrapW - handleSize); //右画面外
            const outT = -(swH - handleSize); //上画面外
            const outB = wrapH - handleSize; //下画面外
            //console.log(data.x, outR, outL)
            if (data.x < outL || outR < data.x || data.y < outT || outB < data.y) {
                //画面外の場合
                // Draggable element center coordinates (x,y)
                const center = {
                    x: wrapW - swW / 2 + data.x,
                    y: data.y + swH / 2,
                };

                // The margin from the draggable's center,
                // to the viewport sides (top, left, bottom, right)
                const margin = {
                    top: center.y - 0,
                    left: center.x - 0,
                    bottom: wrapH - center.y,
                    right: wrapW - center.x,
                };
                // sort and get the nearest viewport side.
                const sorted = Object.keys(margin).sort((a, b) => margin[a] - margin[b]);
                const nearSide = sorted[0];
                // new draggable sticky position`
                const pos = {
                    top: { y: outT, x: data.x },
                    left: { y: data.y, x: outL },
                    bottom: { y: outB, x: data.x },
                    right: { y: data.y, x: outR },
                };
                this.setState({ pos: pos[nearSide] });
            } else {
                //画面内の場合
                this.setState({ pos: { y: data.y, x: data.x } });
            }
        }
    }

    render() {
        let zIndex;
        let sw = this.props.focusName;
        if (sw !== "editer" && sw !== "prob") sw = "menu";

        this.props.focusSw.forEach((el, index) => {
            if (el === sw) zIndex = 100 + index;
        });

        let swP = "SwPop";

        return (
            <Draggable
                cancel="button, .sBtn, input[type=color], input[type=checkbox] + label, input[type=radio] + label,
                input[type=range], input[type=text], select, table"
                onStart={() => this.focusSw(this.props.focusName)}
                position={this.state.pos}
                scale={1}>
                <div className={swP} style={{ zIndex: zIndex }}>
                    <div className="Sw__body" id={this.props.focusName + "_window"}>
                        {this.props.children}
                    </div>
                </div>
            </Draggable>
        );
    }
}

export default connect(mapStateToProps)(SwPop);
//  bounds='body'　draggableの移動範囲指定
